<template>
  <div class="personal-info-container">
    <a-modal
      wrapClassName="personal-info-modal"
      :visible="PersonModalVisible"
      :closable="true"
      title="个人信息"
      @cancel="closeModal"
      :okText="!isEdit ? '修改' : '确定'"
      cancelText="取消"
      :footer="null"
      :maskClosable="false"
    >
      <a-form-model
        class="personal-info-form"
        ref="formRef"
        :model="form"
        :rules="rules"
        layout="vertical"
      >
        <a-form-model-item
          label="所属企业"
          required
          prop="enterpriseName"
        >
          <a-input
            v-if="isEdit"
            placeholder="可输入中英文，15个以内的字符"
            v-model="form.enterpriseName"
            disabled
          ></a-input>
          <div v-else>{{ form.enterpriseName }}</div>
        </a-form-model-item>
        <a-form-model-item
          label="姓名"
          prop="name"
        >
          <a-input
            v-if="isEdit"
            placeholder="可输入中英文，15个以内的字符"
            v-model="form.name"
            allowClear
          ></a-input>
          <div v-else>{{ form.name }}</div>
        </a-form-model-item>
        <a-form-model-item
          label="登录账号"
          required
          prop="loginName"
        >
          <a-input
            v-if="isEdit"
            placeholder="可输入英文数字，15个以内的字符"
            v-model="form.loginName"
            disabled
          ></a-input>
          <div v-else>{{ form.loginName }}</div>
        </a-form-model-item>
        <a-form-model-item
          label="手机号码"
          prop="phone"
        >
          <template v-if="isEdit">
            <a-input
              placeholder="可输入11位数字"
              v-model="form.phone"
              disabled
            >
              <span
                slot="suffix"
                class="reset-phone-text"
                @click="toggleModalType('modifyPhone')"
              >修改</span>
            </a-input>

          </template>
          <div v-else>{{ form.phone || '/' }}</div>
        </a-form-model-item>
        <a-form-model-item
          label="邮箱"
          prop="email"
        >
          <a-input
            v-if="isEdit"
            placeholder="请输入正确的邮箱格式"
            v-model="form.email"
            allowClear
          ></a-input>
          <div v-else>{{ form.email || '/' }}</div>
        </a-form-model-item>
      </a-form-model>
      <!-- 操作按钮 -->
      <a-row
        type="flex"
        justify="end"
        :gutter="20"
        class="operate-btn-group"
      >
        <a-col>
          <a-button @click="handleCancel">取消</a-button>
        </a-col>
        <a-col>
          <a-button
            type="primary"
            @click="handleOk"
          >{{!isEdit ? '修改' : '确认'}}</a-button>
        </a-col>
      </a-row>
    </a-modal>

    <modify-phone
      :visible="PhoneModalVisible"
      :userId="form.id"
      @toggleModalType="toggleModalType"
      @closeModal="closeModal"
      @updatePhone="updatePhone"
    ></modify-phone>
  </div>
</template>

<script>
import {
  getPersonalInfo as getPersonalInfoApi,
  updatePersonalInfo as updatePersonalInfoApi
} from '@/api/personal.js'
import ModifyPhone from './ModifyPhone.vue'
import { setStore, getStore } from '@/utils/storage'
import { checkEmail } from '@/utils'
export default {
  data () {
    return {
      isEdit: false,
      form: {
        id: '',
        enterpriseName: "",
        name: "",
        loginName: "",
        phone: "",
        email: "",
      },
      tempForm: '',
      rules: {
        name: [
          { required: true, message: "姓名必须填写", trigger: "blur" },
          { max: 15, message: "请输入15以内的字符", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (/^[\u4E00-\u9FA5a-zA-Z]+$/.test(value)) {
                return Promise.resolve();
              } else {
                return Promise.reject(new Error("请输入中英文"));
              }
            },
            trigger: "blur",
          },
        ],
        email: [
          {
            type: "email", validator: (rule, value, callback) => {
              if (!value) {
                return Promise.resolve()
              }
              if (checkEmail(value)) { //校验邮箱的格式，还需要校验邮箱的长度
                const pre = value.split('@')[0]
                const suffx = value.split('@')[1]
                if (pre.length > 64 || suffx.length > 255) {
                  return Promise.reject('请输入正确的邮箱格式')
                }
                return Promise.resolve()
              } else {
                return Promise.reject('请输入正确的邮箱格式')
              }
            }, trigger: "blur"
          },
        ]
      },
      PersonModalVisible: true,
      PhoneModalVisible: false
    }
  },
  components: {
    ModifyPhone
  },
  props: {
    visible: {
      type: Boolean,
      default: true
    }
  },
  mounted () {
    this.getPersonalInfo()
  },
  methods: {
    getPersonalInfo () {
      getPersonalInfoApi().then((res) => {
        if (res.code === 1000) {
          let { id, enterpriseName, name, loginName, phone, email } = res.result
          this.form = {
            id, enterpriseName, name, loginName, phone, email
          }
          this.tempForm = JSON.parse(JSON.stringify(this.form))
        }
      }).catch(err => {
        console.log('err', err)
      })
    },
    // 提交个人信息表单信息
    handleOk () {
      // 非编辑状态,为修改按钮：点击修改，转化编辑状态
      // 编辑状态，为保存按钮：点击保存，验证表单信息，进行信息保存、
      if (!this.isEdit) {
        this.isEdit = true
        return
      }

      this.$refs.formRef.validate(valid => {
        if (valid) {
          let { id, name, email } = this.form
          updatePersonalInfoApi({
            id, name, email
          }).then((res) => {
            if (res.code === 1000) {
              this.$message.success('修改成功')
              this.tempForm = JSON.parse(JSON.stringify(this.form))

              this.updateUserInfo()
              this.handleCancel()
            } else {
              this.$message.error(res.message)
            }
          }).catch(err => {
            console.log('err', err)
          })
        } else {
          this.$message.warning('信息填写不准确')
          return false
        }
      })
    },
    // 取消个人信息表单信息
    handleCancel () {
      // 编辑状态：点击取消，转化成非编辑状态
      // 非编辑状态：点击取消，个人信息弹窗消失
      if (this.isEdit) {
        this.$refs.formRef.resetFields()
        this.isEdit = false
        this.form = JSON.parse(JSON.stringify(this.tempForm))
      } else {
        this.$emit('openModal', false)
      }
    },
    // 关闭当前弹窗
    closeModal () {
      this.$emit('openModal', false)
    },
    updatePhone (phone) {
      this.form.phone = phone
      this.tempForm = JSON.parse(JSON.stringify(this.form))

      this.updateUserInfo()
    },
    // 切换个人信息与修改密码弹窗类型
    toggleModalType (modalName) {
      if (modalName === 'modifyPhone') {
        this.PhoneModalVisible = true
        this.PersonModalVisible = false
      } else if (modalName === 'personalInfo') {
        this.PhoneModalVisible = false
        this.PersonModalVisible = true
      }
    },
    // 修改个人信息，手机号码，同步到浏览器本地缓存\vuex中
    updateUserInfo () {
      let userInfo = JSON.parse(getStore('userInfo'))
      userInfo = {
        ...userInfo,
        ...this.form
      }
      this.$store.commit('SET_USERINFO', userInfo)
      setStore('userInfo', JSON.stringify(userInfo))
    }
  },
}
</script>

<style lang="less" scoped>
.personal-info-form {
  .reset-phone-text {
    display: inline-block;
    height: 30px;
    line-height: 30px !important;
    cursor: pointer;
  }
}
.operate-btn-group {
  margin-top: 100px;
}
</style>
<style lang="less">
.personal-info-modal {
  .house-modal-content {
    width: 492px;
    // height:717px;
  }
}
</style>
